interface Props {
  anglerName: string;
  clubName: string;
  onClear: () => void;
}

export function OnBehalfBanner({ anglerName, clubName, onClear }: Props) {
  return (
    <div className="mb-4 flex items-center justify-between rounded-lg border border-amber-300 dark:border-amber-700 bg-amber-50 dark:bg-amber-900/30 px-4 py-2 text-sm text-amber-800 dark:text-amber-200">
      <span>
        Logging catch for <strong>{anglerName}</strong> in <strong>{clubName}</strong>.
      </span>
      <button
        type="button"
        onClick={onClear}
        className="text-xs underline hover:no-underline"
      >
        Log for myself instead
      </button>
    </div>
  );
}
